import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _cloneDeep from 'lodash.clonedeep'

import './styles.scss'
import TitleCard from './TitleCard'
import NotificationsCard from './NotificationsCard'
import ConversationsNotificationsCard from './ConversationsNotificationsCard'
import NotificationsDeliveryCard from './NotificationsDeliveryCard'
import SoundConfigurationCard from './SoundConfigurationCard'
import ScheduleNotificationsCard from './ScheduleNotificationsCard'
import { operator } from 'api'
import { updateNotifications } from '../../../redux/currentNotifications/actions'
import { getTone } from 'utils/statics'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'

const Index = () => {
  const dispatch = useDispatch()
  const { currentNotifications } = useSelector(store => store)
  const [channels, setChannels] = React.useState([])
  const [fieldStatus, setFieldStatus] = React.useState({})

  React.useEffect(() => {
    getChannelsList()
  }, [])

  const getChannelsList = () => {
    operator.channels.getList()
      .then(({ data }) => setChannels(data))
  }

  const playSound = (sound) => {
    if (sound && sound !== 'none') {
      const audio = new Audio(getTone(`/${sound}.mp3`))
      audio.play()
    }
  }

  const handleChannelsSound = ({ action, index, value }) => {
    const channelsSound = _cloneDeep(currentNotifications.channels || [])

    if (action === 'new') {
      channelsSound.push({
        hub: '',
        key: '',
        sound: 'default'
      })
    }
    if (action === 'update') {
      channelsSound[index] = { ...channelsSound[index], ...value }
    }
    if (action === 'remove') {
      channelsSound.splice(index, 1)
    }

    handleSave({ fieldName: 'channels', fieldValue: channelsSound })
  }

  const handleNotificationsDelivery = ({ field, value }) => {
    const delivery = _cloneDeep(currentNotifications.delivery || {})

    if (field === 'desktop') {
      delivery.desktop = value
      delivery.app = value
    } else {
      delivery[field] = value
    }

    handleSave({ fieldName: 'delivery', fieldValue: delivery, innerFieldName: field })
  }

  const handleSave = ({ fieldName, fieldValue, innerFieldName }) => {
    setFieldStatus(prevState => ({ ...prevState, [innerFieldName || fieldName]: 'PENDING' }))
    dispatch(updateNotifications({ [fieldName]: fieldValue }))
      .then(status => {
        setFieldStatus(prevState => ({ ...prevState, [innerFieldName || fieldName]: status }))
        if (status === 'OK') {
          SaveToastNotification.ok()
        } else if (status === 'ERROR') {
          SaveToastNotification.error()
        }
      })
  }

  return (
    <div className='animated fadeIn'>
      <div className='notifications-configuration'>
        <div className='section'>
          <TitleCard
            checked={currentNotifications.isActive}
            setChecked={handleSave}
          />
          <NotificationsCard
            generalList={currentNotifications.generalList}
            assignedList={currentNotifications.assignedList}
            inChat={currentNotifications.inChat}
            setChecked={handleSave}
          />
          <ConversationsNotificationsCard
            textMsg={currentNotifications.textMsg}
            note={currentNotifications.note}
            voiceNote={currentNotifications.voiceNote}
            pdf={currentNotifications.pdf}
            imageVideo={currentNotifications.imageVideo}
            location={currentNotifications.location}
            setChecked={handleSave}
          />
          <SoundConfigurationCard
            channels={channels}
            duration={currentNotifications.duration}
            withPreview={currentNotifications.withPreview}
            sound={currentNotifications.sound}
            inChatSound={currentNotifications.inChatSound}
            channelsSound={currentNotifications.channels}
            handleChannelsSound={handleChannelsSound}
            setChecked={handleSave}
            playSound={playSound}
          />
          <NotificationsDeliveryCard
            delivery={currentNotifications.delivery}
            emailInterval={currentNotifications.emailInterval}
            inChatEmailInterval={currentNotifications.inChatEmailInterval}
            setChecked={handleSave}
            handleNotificationsDelivery={handleNotificationsDelivery}
          />
          <ScheduleNotificationsCard
            schedule={currentNotifications.schedule}
            onChange={handleSave}
            fieldStatus={fieldStatus}
          />
        </div>
      </div>
    </div>
  )
}

export default Index
